import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import "./manualReviewVerifyRTW.scss";
import DatePicker from "react-datepicker";
import Moment from "moment";

import {
  Form,
  Row,
  Col,
  Button,
  Input,
  InputNumber,
  Drawer,
  Radio,
  Space,
} from "antd";
import { ToastContainer, toast } from "react-toastify";
import * as service from "./manualReviewVerifyRTWService";
import Spinner from "../common/spinner";
import { log } from "../../helper/helper";
import UploadCertificate from "./UploadFile";

function ManualReviewVerifyRTW(props) {
  const [isLoading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [residencyStatus, setResidencyStatus] = useState(null);
  const [workingCondition, setWorkingCondition] = useState(null);
  const [form] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [certificateUrl, setSertificateUrl] = useState("");
  const [riderInfo, setRiderInfo] = useState();
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const onNewCertificateUrl = (value) => {
    setSertificateUrl(value);
  };

  const onFileName = (value) => {
    form.setFieldsValue({
      uploadFile: value,
    });
  };

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
    });
  }, []);

  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const DatePickerWrapper = ({ value, onChange }) => {
    return (
      <DatePicker
        selected={value}
        onChange={(date) => onChange(date)}
        dateFormat="yyyy-MM-dd"
        className="manual-review-ant-react-date-picker"
      />
    );
  };

  const onSearchRider = async (value) => {
    const formattedDate = Moment(value.birth).format("YYYY-MM-DD");

    setLoading(true);
    try {
      const result = await service.adminFindRider(value.email, formattedDate);
      log(result.data);
      setLoading(false);
      if (result) {
        switch (result.data.code) {
          case 200:
            setRiderInfo(result.data);
            showDrawer();
            return;
          case 401:
            toast.error(result.data.message);
            return this.props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
  };

  const onVerifyRider = async (value) => {
    const dateIssue = Moment(value.dateIssue).format("YYYY-MM-DD");
    const visaExpiryDate = value.visaExpiryDate
      ? Moment(value.visaExpiryDate).format("YYYY-MM-DD")
      : null;
    const visaGrantDate = value.visaGrantDate
      ? Moment(value.visaGrantDate).format("YYYY-MM-DD")
      : null;
    const residency =
      value.residency === "Australia/New Zealand Citizen" ? true : false;
    const workingUnlimited =
      workingCondition === "Unlimited rights to work" ? true : false;

    setLoading(true);
    try {
      const result = await service.adminRiderDocumentManualReviewVerifyRTW(
        riderInfo && riderInfo.rider_uid,
        residency,
        visaGrantDate,
        workingUnlimited,
        visaExpiryDate,
        value.workingLimit,
        value.visaSubclass,
        value.workArea,
        value.codeOne,
        value.codeTwo,
        certificateUrl.trim(),
        dateIssue
      );
      log(result.data);
      setLoading(false);
      if (result) {
        switch (result.data.code) {
          case 200:
            searchForm.setFieldsValue({
              email: "",
              birth: "",
            });
            form.resetFields();
            onClose();
            toast.success(result.data.message);
            return;
          case 401:
            toast.error(result.data.message);
            return this.props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      log(error);
      toast.error(error.message);
    }
  };

  return (
    <div className="manual-review">
      <ToastContainer />
      {renderSpinner()}
      <div className="headline">
        <h3>Manual Review Right To Work</h3>
      </div>
      <Form
        name="basic"
        initialValues={{}}
        onFinish={onSearchRider}
        autoComplete="off"
        style={{ width: "100%", padding: 40 }}
        layout="vertical"
        form={searchForm}
      >
        <Row gutter={50}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  required: true,
                  message: "Please enter a valid email address",
                },
              ]}
            >
              <Input size="large" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item
              name="birth"
              label="Date of birth"
              rules={[
                {
                  required: true,
                  message: "Please enter your birthday",
                },
              ]}
            >
              <DatePickerWrapper />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Form.Item className="register-btn" style={{ textAlign: "right" }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={isLoading}
                style={{
                  width: 200,
                  marginTop: "30px",
                }}
              >
                Search
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Drawer
        title="Rider"
        closable={{ "aria-label": "Close Button" }}
        onClose={onClose}
        open={open}
      >
        <Form
          name="rider"
          initialValues={{}}
          onFinish={onVerifyRider}
          autoComplete="off"
          style={{ width: "100%", padding: 20 }}
          layout="vertical"
          form={form}
        >
          <Row gutter={50}>
            <Col span={24}>
              <Form.Item
                label="Code 1"
                name="codeOne"
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                  {
                    validator: (_, value) => {
                      const trimmed = (value || "").replace(/\s/g, "");
                      const isValid = /^[a-zA-Z0-9]{2,}$/.test(trimmed);
                      return isValid
                        ? Promise.resolve()
                        : Promise.reject(
                            "Must contain at least 2 letters or numbers"
                          );
                    },
                  },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Code 2"
                name="codeTwo"
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                  {
                    validator: (_, value) => {
                      const trimmed = (value || "").replace(/\s/g, "");
                      const isValid = /^[a-zA-Z0-9]{2,}$/.test(trimmed);
                      return isValid
                        ? Promise.resolve()
                        : Promise.reject(
                            "Must contain at least 2 letters or numbers"
                          );
                    },
                  },
                ]}
              >
                <Input size="large" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Date Issue"
                name="dateIssue"
                rules={[
                  {
                    required: true,
                    message: "Please picke issue date",
                  },
                ]}
              >
                <DatePickerWrapper />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Residency Status"
                name="residency"
                rules={[
                  {
                    required: true,
                    message: "Please select your citizen status",
                  },
                ]}
              >
                <Radio.Group
                  onChange={(e) => {
                    setResidencyStatus(e.target.value);
                    form.setFieldsValue({
                      visaGrantDate: undefined,
                      visaExpiryDate: undefined,
                      visaSubclass: "",
                      workingLimit: undefined,
                      workArea: "",
                      workingCondition: null,
                    });
                    setWorkingCondition(null);
                  }}
                >
                  <Radio value="Australia/New Zealand Citizen">
                    Australia/New Zealand Citizen
                  </Radio>
                  <Radio value="On a valid visa">On a valid visa</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {residencyStatus === "On a valid visa" && (
              <>
                <Col span={24}>
                  <Form.Item
                    label="Working Condition"
                    name="workingCondition"
                    rules={[
                      {
                        required: true,
                        message: "Please select your working condition",
                      },
                    ]}
                  >
                    <Radio.Group
                      onChange={(e) => {
                        setWorkingCondition(e.target.value);
                        form.setFieldsValue({
                          workingLimit: null,
                          workArea: "",
                          visaExpiryDate: undefined,
                          visaSubclass: "",
                        });
                      }}
                    >
                      <Radio value="Unlimited rights to work">
                        Unlimited rights to work
                      </Radio>
                      <Radio value="Limited">Limited</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {workingCondition !== null && (
                  <>
                    <Col span={24}>
                      <Form.Item
                        label="Visa Grant Date"
                        name="visaGrantDate"
                        rules={[
                          {
                            required: true,
                            message: "Please pick visa grant date",
                          },
                        ]}
                      >
                        <DatePickerWrapper />
                      </Form.Item>
                    </Col>
                    {workingCondition === "Limited" && (
                      <>
                        <Col span={24}>
                          <Form.Item
                            label="Visa Subclass"
                            name="visaSubclass"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input size="large" />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="Visa Expiry Date"
                            name="visaExpiryDate"
                            rules={[
                              {
                                required: true,
                                message: "Please pick visa expiry date",
                              },
                            ]}
                          >
                            <DatePickerWrapper />
                          </Form.Item>
                        </Col>

                        <Col span={24}>
                          <Form.Item
                            label="Working limit(H/W)"
                            name="workingLimit"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <InputNumber
                              style={{ width: "100%" }}
                              size="large"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            label="Work area & Visa condition"
                            name="workArea"
                          >
                            <Input.TextArea allowClear />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </>
                )}
              </>
            )}
            <Col span={24}>
              <Space>
                <Form.Item
                  label="Upload file"
                  name="uploadFile"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input disabled style={{ width: "100%" }} size="large" />
                </Form.Item>
                <UploadCertificate
                  onNewCertificateUrl={onNewCertificateUrl}
                  onFileName={onFileName}
                  riderId={riderInfo && riderInfo.rider_uid}
                />
              </Space>
            </Col>
            {/* )} */}
            <Col span={24}>
              <Form.Item
                className="register-btn"
                style={{ textAlign: "right" }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  loading={isLoading}
                  style={{
                    marginTop: "30px",
                  }}
                >
                  Verify
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
}

export default ManualReviewVerifyRTW;
